import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const solutions = [{
  title: 'Identificar y destruir creencias limitantes',
  desc: 'Ve al origen exacto de tus bloqueos y elimínalos con un método paso a paso sin necesidad de años de terapia.'
}, {
  title: 'Técnicas de Visualización Creativa',
  desc: 'Aprende cómo enviar la señal correcta al universo para que tus deseos dejen de ser pensamientos y se conviertan en realidad tangible.'
}, {
  title: 'El Mapa de tu Vida Soñada',
  desc: 'Pasos prácticos y claros para pasar del pensamiento a la realidad. Sin vaguedad, sin esperar milagros.'
}, {
  title: 'Gestión Emocional de Alta Vibración',
  desc: 'Mantén tu frecuencia elevada incluso en los momentos difíciles. Herramientas para no "caer" cuando el proceso se pone duro.'
}];
export function SolutionSection() {
  return <section className="py-20 bg-gradient-to-b from-primary to-[#0D1220] relative" data-id="element-207" data-mp="fua0n5pib9nk">
      <div className="max-w-[1100px] mx-auto px-5" data-id="element-208" data-mp="36avs54hu4v70">
        <div className="text-center md:text-left mb-12" data-id="element-209" data-mp="36cgmat08mc4c">
          <span className="inline-block text-xs font-semibold tracking-[0.15em] uppercase text-violet-light mb-4" data-id="element-210" data-mp="3b8xa1m3iyogw">
            La Solución
          </span>
          <h2 className="font-display text-3xl md:text-[42px] font-bold leading-[1.2] text-white" data-id="element-211" data-mp="3fdeu7mdsr3s7">
            Lo que vas a <span className="text-gradient-violet" data-id="element-212" data-mp="3p9hu0ll6eqbz">lograr con este sistema:</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center mb-20" data-id="element-213" data-mp="3u8b7wf4dkjco">
          <div className="flex flex-col gap-5" data-id="element-214" data-mp="3u68bndcmptzi">
            {solutions.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex gap-4 items-start p-5 bg-card border border-gold/15 rounded-2xl hover:border-gold/35 hover:shadow-[0_0_30px_rgba(212,175,55,0.15)] transition-all group" data-id="element-215" data-mp="2w9jsptk6kx5" data-mpi={i}>
                <div className="shrink-0 w-7 h-7 bg-gradient-to-br from-violet to-violet-dark rounded-full flex items-center justify-center mt-0.5 shadow-md" data-id="element-216" data-mp="27yhub9fu5glo">
                  <Check className="w-4 h-4 text-white" data-id="element-217" data-mp="2mofp4889t4ju" />
                </div>
                <div data-id="element-218" data-mp="2hul6z98bcxmv">
                  <h3 className="font-bold text-gold text-[15px] mb-1 group-hover:text-gold-light transition-colors" data-id="element-219" data-mp="2vnaszdnue2jz">{item.title}</h3>
                  <p className="text-sm text-gray-400 leading-relaxed" data-id="element-220" data-mp="2rmh34equadog">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <div className="hidden md:flex relative items-center justify-center" data-id="element-221" data-mp="35j4bres5msa7">
            <div className="w-[320px] h-[320px] rounded-full bg-[radial-gradient(ellipse_at_center,rgba(124,58,237,0.15)_0%,transparent_70%)] border border-violet/20 flex items-center justify-center relative animate-spin-slow" data-id="element-222" data-mp="30kaztqsin9c5">
              <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-gold rounded-full shadow-[0_0_10px_#D4AF37]" data-id="element-223" data-mp="3hvzqsg8epulk" />
              <div className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-violet-light rounded-full shadow-[0_0_10px_#9D5FF0]" data-id="element-224" data-mp="3mtrjhcgvlkqt" />
              
              <div className="w-[200px] h-[200px] rounded-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.15)_0%,transparent_70%)] border border-gold/30 flex flex-col items-center justify-center absolute text-center p-5 animate-spin-slow-reverse" data-id="element-225" data-mp="3d4zvffexrkl6">
                <div className="text-4xl mb-2" data-id="element-226" data-mp="345wae5w7kv41">✨</div>
                <div className="font-display text-[13px] text-gold font-bold leading-[1.3]" data-id="element-227" data-mp="2p7kei1gntqdx">Tu Vida<br data-id="element-228" data-mp="2u65h27jdwm5j" />de Ensueño</div>
              </div>
            </div>
          </div>
        </div>

        {/* Added Image 11 */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-[800px] mx-auto rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.4)] border border-gold/20" data-id="element-229" data-mp="nffncs6zix49">
          <img src="https://cdn.magicpatterns.com/uploads/4FkkBiJ2LwRwyvYQBKLmCN/11.png" alt="Inspiración de Vida" className="w-full h-auto object-cover" data-id="element-230" data-mp="2kfsd289dke13" />
        </motion.div>
      </div>
    </section>;
}